<template>
  <div v-html="svgString"></div>
</template>
 
<script>
  import { store } from '@/store/index';
  import getSVG from '../../services/svgs';

  export default {
    props: [
      'svgName'
    ],
    computed: {
      svgString: function () {
        return getSVG(this.svgName, this.$vuetify.theme.lightThemeColor);
      }
    }
  }
</script>